import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { SeasonalityIcon } from '@sorare/core/src/atoms/icons/SeasonalityIcon';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { PrintablePlayerSortName } from '@sorare/core/src/contexts/config';
import { glossary } from '@sorare/core/src/lib/glossary';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';
import { priceSorts } from '@sorare/core/src/lib/scouting-center';

import { useManagePlayerSearchView } from 'searchCommonPlayer/StatsManager/useManagePlayerSearchView';

import { SortTable } from '../SortTable';

const StyledLabelS = styled(LabelS)`
  vertical-align: middle;
`;

type Props = {
  sorts: PrintablePlayerSortName[];
  refine: (_sorts: PrintablePlayerSortName[]) => void;
};

export const SortByPrice = ({ sorts, refine }: Props) => {
  const { statsManager } = useManagePlayerSearchView();

  const indexes = priceSorts(
    statsManager[PlayerSearchViewAttributes.RARITY],
    statsManager[PlayerSearchViewAttributes.SEASONALITY]
  );

  const label = (
    <Horizontal gap={1}>
      <SeasonalityIcon
        seasonality={statsManager[PlayerSearchViewAttributes.SEASONALITY]}
      />
      <StyledLabelS>
        <FormattedMessage {...glossary.lowestPrice} />
      </StyledLabelS>
    </Horizontal>
  );

  return (
    <SortTable ascFirst indexes={indexes} sorts={sorts} refine={refine}>
      {label}
    </SortTable>
  );
};
